require('./expensesByCategoryViewNew.scss');

// @ vendors
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

// @components
import { OKCover } from 'commonsComponents/OKCover';
import { OKHeaderSubPage } from 'commonsComponents/OKHeaderSubPage';
import ExpensesByCategoryHistogram from './expensesByCategoryHistogram/expensesByCategoryHistogram';
import { ExpensesByCategoryMonthly } from './expensesByCategoryMonthly/expensesByCategoryMonthly';
import ExpensesByCategoryTabSelector from './expensesByCategoryTabSelector/expensesByCategoryTabSelector';
import ExpensesByCategoryInfo from './expensesByCategoryInfo/expensesByCategoryInfo';
import { OKLoadingErrorMessage } from "commonsComponents/OKLoadingErrorMessage";
import ExpensesByCategoryViewNewTable from "./expensesByCategoryViewNewTable/expensesByCategoryViewNewTable";

// @ actions
import { requestListCategories } from 'actions/expensesByCategories/expensesByCategoriesListCategories';
import { requestHistogram, requestCategoryMovements } from 'actions/expensesByCategories/expensesByCategoriesMovements';
import { requestCategoriesTabs } from 'actions/expensesByCategories/ExpensesByCategoriesTabSelector';
import { fallbackFilters, resetFilters} from 'actions/expensesByCategories/clearFiltersModal';
import { initFilter, initCheckFilter, initDateFilter, setSelectFilter, setDateFilter, setApplied } from 'actions/filters'

// @utilities
import { getCategoryIcon } from 'utilities/expensesByCategories/categoriesUtilities';
import getFiltersObjectToRequestData from './commons/helpers/getFiltersObjectToRequestData'
import getBanksFromAggregatorData from 'utilities/aggregator/getBanksFromAggregatorData';
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @constants
import { PFM_FILTERS } from 'constants/index';
import { ENABLED_CREDIT_CARD_FILTER } from 'constants/flagBasedFeatures';
import { CATEGORY, ALL_CATEGORIES, BANK, DATE, CUSTOM_ACCOUNTS, ALL_ACCOUNTS, LAST_YEAR_COMPARISON, CONTRACT_TYPE } from 'constants/expensesByCategories/filters';

class ExpensesByCategoryView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filtersWhenOpenModal: {},
            hasAppliedFilters: true,
            setDateFilter: false
        }
        initFilter(PFM_FILTERS)
    }

    componentDidMount() {
        const { requestListCategories, setApplied, initCheckFilter, initDateFilter, immFilters } = this.props;
        const isActive = !!immFilters ? immFilters.getIn([CUSTOM_ACCOUNTS, 'active']) : true;

        requestListCategories();
        if (!this.state.setDateFilter) {
            initDateFilter(PFM_FILTERS, DATE, true, 'Custom', 'dateFilter', moment().startOf('month'), moment().startOf('day'), true);
            initCheckFilter(PFM_FILTERS, CUSTOM_ACCOUNTS, isActive, 'checkFilter', CUSTOM_ACCOUNTS, formatText('typeAccountFilter-customAccounts'), true);
            setApplied(PFM_FILTERS)
        }
    }

    componentDidUpdate(prevProps) {
        const { immFilters } = this.props;
        const { setDateFilter } = this.state;

        if (immFilters.getIn(['date', 'active']) && !setDateFilter) {
            this.setState({
                setDateFilter: true
            }, () => {
                this.getHistogramData(immFilters)
                this.getCategoriesTabsData(immFilters)
                this.getMovementsBySelectedCategory(immFilters)
            })
        }

        this.manageFetchHistogramData(prevProps)
        this.manageFetchMovementsData(prevProps)
    }

    manageFetchHistogramData = prevProps => {
        const { immFilters } = this.props
        const filtersToCheck = [CATEGORY, LAST_YEAR_COMPARISON, BANK];

        if (this.areThereChangesInSomeFilters(prevProps.immFilters, immFilters, filtersToCheck)) {
            this.getHistogramData(immFilters)
        }
    }

    manageFetchMovementsData = prevProps => {
        const { immFilters } = this.props
        const filtersToCheck = [DATE, BANK];

        if (this.areThereChangesInSomeFilters(prevProps.immFilters, immFilters, filtersToCheck)) {
            this.getMovements()
        }
    }

    areThereChangesInSomeFilters = (previousFilters, currentFilters, filtersIdsToCheck = []) => {
        return filtersIdsToCheck.some((filterId) => {
            if(filterId !== 'date') {
                return (previousFilters
                    && currentFilters
                    && (
                        previousFilters.getIn([filterId, 'selected']) !== currentFilters.getIn([filterId, 'selected']) ||
                        previousFilters.getIn([filterId, 'active']) !== currentFilters.getIn([filterId, 'active'])
                    ))
            } else {
                return (previousFilters
                    && currentFilters
                    && (
                        previousFilters.getIn([filterId, 'filterTagFrom']) !== currentFilters.getIn([filterId, 'filterTagFrom']) ||
                        previousFilters.getIn([filterId, 'filterTagTo']) !== currentFilters.getIn([filterId, 'filterTagTo'])
                    ))
            }
        })
    }

    getHistogramData = (immFilters) => {
        const { requestHistogram, immAccounts, immCards, immAggregatorData, isPfmAggregatorView } = this.props
        const filtersObject = getFiltersObjectToRequestData(immFilters, immAccounts, immCards, immAggregatorData, isPfmAggregatorView);

        requestHistogram(filtersObject, isPfmAggregatorView);
    }

    getCategoriesTabsData = immFilters => {
        const { requestCategoriesTabs, immAccounts, immCards, immAggregatorData, isPfmAggregatorView } = this.props
        const filtersObject = getFiltersObjectToRequestData(immFilters, immAccounts, immCards, immAggregatorData, isPfmAggregatorView)

        requestCategoriesTabs(filtersObject);
    }

    getFilterObject = () => {
        const { immFilters, immAccounts, immCards, immAggregatorData, isPfmAggregatorView } = this.props
        const filtersObject = getFiltersObjectToRequestData(immFilters, immAccounts, immCards, immAggregatorData, isPfmAggregatorView)
        return filtersObject;
    }

    changeCategoryFilter = categoryCode => {
        this.props.setSelectFilter(PFM_FILTERS, CATEGORY, true, categoryCode, null, 'selectorFilter', null, null, false);
    }

    handleOnFilter = () => {
        const { immFilters } = this.props
        this.getHistogramData(immFilters)
        this.getCategoriesTabsData(immFilters)
        this.getMovementsBySelectedCategory(immFilters)
        this.setState({ hasAppliedFilters: true})
    }

    getMovementsBySelectedCategory = immFilters => {
        const hasSelectedCategory = immFilters.getIn([CATEGORY, 'selected']) && immFilters.getIn([CATEGORY, 'selected']) !== ALL_CATEGORIES
        if (hasSelectedCategory) {
            let selectedCategoryCode = immFilters.getIn([CATEGORY, 'selected'])
            this.getMovementsByCategoryCode(selectedCategoryCode);
        }
    }

    getMovementsByCategoryCode = categoryCode => {
        const { requestCategoryMovements, immFilters, immAccounts, immCards, immAggregatorData, isPfmAggregatorView } = this.props
        const filtersObject = getFiltersObjectToRequestData(immFilters, immAccounts, immCards, immAggregatorData, isPfmAggregatorView)
        filtersObject.categorySelected = categoryCode
        requestCategoryMovements(filtersObject, isPfmAggregatorView);
    }

    getMovements = async () => {
        const { requestCategoryMovements, immFilters, immAccounts, immCards, immAggregatorData, categoriesList, categoriesTabSelector, isPfmAggregatorView} = this.props;
        const filtersObject = await getFiltersObjectToRequestData(immFilters, immAccounts, immCards, immAggregatorData, isPfmAggregatorView)
        
        if (filtersObject.categorySelected[0] === ALL_CATEGORIES) {
            const { tabDataList } = this.getCategoriesData(categoriesList, categoriesTabSelector)
            const categorySelected = this.getSelectedCategoryData(immFilters, tabDataList)
            filtersObject.categorySelected = categorySelected.categoryCode
        } else {
            filtersObject.categorySelected = filtersObject.categorySelected[0]
        }

        requestCategoryMovements(filtersObject, isPfmAggregatorView);
    }

    getCategoriesData = (categoryList, movements) => {
        const { immFilters } = this.props;
        const movementsFilteredByDate = movements.filter((m) => moment(m.get('fecha')).isBetween(immFilters.getIn(['date','from']), immFilters.getIn(['date','to'])));
        if (movementsFilteredByDate.size > 0) {
            let { tabDataMap, totalAmount } = movementsFilteredByDate.reduce(this.createTabsData, { tabDataMap: new Map(), totalAmount: 0 })
            let orderedTabDataList = this.getOrderedTabDataList(tabDataMap)
            orderedTabDataList = this.moveToEndListIncomeCategoryIfExist(orderedTabDataList);
            orderedTabDataList = this.moveToEndListExcludeCategoryIfExist(orderedTabDataList);
            let completeDataTabList = this.addTabsDataForCategoriesWithoutMovements(orderedTabDataList, categoryList)
            return { tabDataList: completeDataTabList, totalAmount }
        } else {
            const tabDataList = this.addTabsDataForCategoriesWithoutMovements([], categoryList)
            return { tabDataList, totalAmount: 0 }
        }
    }

    createTabsData = (accumulator, movement) => {
        accumulator.tabDataMap.set(movement.get('categoryCode'),{
            amount: accumulator.tabDataMap.get(movement.get('categoryCode')) ? accumulator.tabDataMap.get(movement.get('categoryCode')).amount + Math.abs(movement.get('monto')) : Math.abs(movement.get('monto')),
            categoryName: movement.get('category'),
            categoryIcon: getCategoryIcon(movement.get('categoryCode')),
            categoryCode: movement.get('categoryCode'),
            movementsAmount: accumulator.tabDataMap.get(movement.get('categoryCode')) ? accumulator.tabDataMap.get(movement.get('categoryCode')).movementsAmount +  movement.get('count'): movement.get('count'),
        })
        accumulator.totalAmount += Math.abs(movement.get('monto'))
        return accumulator
    }

    getOrderedTabDataList = tabDataMap => {
        let auxiliaryList = []
        tabDataMap.forEach(tabData => {
            auxiliaryList.push(tabData)
        });
        return auxiliaryList.sort(this.sortDescending)
    }

    sortDescending = (a, b) => b.amount - a.amount
    
    moveToEndListIncomeCategoryIfExist = (orderedTabDataList = []) => {
        const INCOME_CATEOGRY_CODE = 5;

        const { newOrderedTabDataList, incomeCategoryTabData } = orderedTabDataList.reduce(this.extractIncomeCategoryTabDataIfExist,
            { newOrderedTabDataList: [], incomeCategoryTabData: undefined, INCOME_CATEOGRY_CODE})

        incomeCategoryTabData && newOrderedTabDataList.push(incomeCategoryTabData);

        return newOrderedTabDataList;
    }

    moveToEndListExcludeCategoryIfExist = (orderedTabDataList = []) => {
        const EXCLUDE_CATEGORY_CODE = 7;

        const { newOrderedTabDataList, excludeCategoryTabData } = orderedTabDataList.reduce(this.extractExcludeCategoryTabDataIfExist,
            { newOrderedTabDataList: [], excludeCategoryTabData: undefined, EXCLUDE_CATEGORY_CODE})

        excludeCategoryTabData && newOrderedTabDataList.push(excludeCategoryTabData);

        return newOrderedTabDataList
    }

    extractIncomeCategoryTabDataIfExist = (accumulator, tabData) => {
        tabData.categoryCode !== accumulator.INCOME_CATEOGRY_CODE ?
            accumulator.newOrderedTabDataList.push(tabData) :
            accumulator.incomeCategoryTabData = tabData

        return accumulator
    }

    extractExcludeCategoryTabDataIfExist = (accumulator, tabData) => {
        tabData.categoryCode !== accumulator.EXCLUDE_CATEGORY_CODE ?
            accumulator.newOrderedTabDataList.push(tabData) :
            accumulator.incomeCategoryTabData = tabData

        return accumulator
    }

    addTabsDataForCategoriesWithoutMovements = (tabDataList = [], categoryList) => {
        let anotherTabDataList = []
        categoryList.toJS().forEach(category => {
            if(!tabDataList.some(dataTab => dataTab.categoryCode === category.code)) {
                anotherTabDataList.push({
                    amount: 0,
                    categoryName: category.key,
                    categoryIcon: getCategoryIcon(category.code),
                    categoryCode: category.code,
                    movementsAmount: 0
                })
            }
        });
        return tabDataList.concat(anotherTabDataList)
    }

    getSelectedCategoryData = (immFilters, tabDataList) => {
        if (tabDataList.length > 0) {
            const selectedCategoryId = immFilters ? immFilters.getIn(['category', 'selected']) : ALL_CATEGORIES;
            return selectedCategoryId === ALL_CATEGORIES ?
                tabDataList[0] :
                tabDataList.find(tabData => tabData.categoryCode === selectedCategoryId);
        } else {
            return {}
        }
    }

    checkActivedFilters = immFilters => {
        if (!this.state.hasAppliedFilters) {
            return false
        }
        return ((immFilters.getIn([DATE, 'selected']) && immFilters.getIn([DATE, 'selected']) !== 'None') ||
            immFilters.getIn([CUSTOM_ACCOUNTS, 'active']) ||
            (immFilters.getIn([CONTRACT_TYPE, 'selected']) && immFilters.getIn([CONTRACT_TYPE, 'selected']) !== ALL_ACCOUNTS))? true :
            false;
    }

    handleClearFilter = () => {
        this.props.fallbackFilters(this.state.filtersWhenOpenModal)
        this.setState({ hasAppliedFilters: true})
    }

    handleResetFilters = () => this.props.resetFilters()

    handleOnOpenModal = () => {
        this.saveFiltersWhenOpenedModal()
        this.setState({ hasAppliedFilters: false})
    }

    saveFiltersWhenOpenedModal = () => this.setState({ filtersWhenOpenModal: this.props.immFilters})

    getOpenBankBreadCrumb = () => [{
        text: formatText('breadcrumb-global'),
        url: '/myprofile/global'
    }, {
        text: formatText('cards-expenses'),
        url: ''
    }]

    getAgregatedBanksBreadCrumb = () => [{
        text: formatText('breadcrumb-global'),
        url: '/myprofile/global'
    }, {
        text: formatText('breadcrumb-otherBanks'),
        url: '/myprofile/global/entities/accounts'
    }, {
        text: formatText('breadcrumb-incomeAndExpenses'),
        url: ''
    }]

    getBreadCrumb = isPfmAggregatorView => isPfmAggregatorView ? this.getAgregatedBanksBreadCrumb() : this.getOpenBankBreadCrumb()

    getMovementsInfo = movementsData => {
        let movementsQuantity = 0, movementsTotalAmount = 0;

        if (movementsData) {
            const movementList = movementsData.toJS()

            movementsQuantity = movementList.length
            movementsTotalAmount = movementList.reduce((total, movement) => total + movement.monto, 0)
        }

        return {movementsQuantity, movementsTotalAmount}
    }

    render() {
        const {
            bankList,
            categoriesList,
            histogramDatatError,
            histogramDataFetching,
            chartData,
            categoriesTabSelector,
            categoriesListFetching,
            categoriesListError,
            chartDataCompare,
            error,
            errorCompare,
            fetching,
            fetchingCompare,
            currency,
            immFilters,
            immCards,
            immAccounts,
            isPfmAggregatorView,
            immFlagBasedFeatures,
            movementsData
        } = this.props;

        const { tabDataList, totalAmount: categoryTotalAmount } = this.getCategoriesData(categoriesList, categoriesTabSelector)
        const selectedCategory = this.getSelectedCategoryData(immFilters, tabDataList),
            hasActivedFilters = immFilters ? this.checkActivedFilters(immFilters) : false;
        const { movementsQuantity, movementsTotalAmount } = this.getMovementsInfo(movementsData)

        const hasCreditCardCountry = immFlagBasedFeatures.get(ENABLED_CREDIT_CARD_FILTER)

        return (
            <div className="expenses-by-category">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover
                            size="medium"
                            section="pg"
                            customClass="col-xs-12"
                        >
                            <OKHeaderSubPage
                                breadcrumbConfig={this.getBreadCrumb(isPfmAggregatorView)}
                                finalTitle={getFinalTitle(isPfmAggregatorView ? 'otherBanks-expenses' : 'cards-expenses')}
                            >
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="global-position grid-view--content-position-negative">
                                <ExpensesByCategoryHistogram
                                    chartData={chartData}
                                    hasCreditCardCountry={hasCreditCardCountry}
                                    chartDataCompare={chartDataCompare}
                                    histogramDataFetching={histogramDataFetching}
                                    histogramDatatError={histogramDatatError}
                                    categoriesList={categoriesList}
                                    bankList={bankList}
                                    onFilter={this.handleOnFilter}
                                    onClearFilter={this.handleClearFilter}
                                    onOpenModal={this.handleOnOpenModal}
                                    error={error}
                                    errorCompare={errorCompare}
                                    fetching={fetching}
                                    fetchingCompare={fetchingCompare}
                                    currency={currency}
                                    immFilters={immFilters}
                                    isPfmAggregatorView={isPfmAggregatorView}
                                />
                                <ExpensesByCategoryMonthly currency={currency} getFilterObject={this.getFilterObject}/>
                                <OKLoadingErrorMessage isLoading={categoriesListFetching} isError={categoriesListError}>
                                    <ExpensesByCategoryTabSelector
                                        tabDataList={tabDataList}
                                        selectedCategoryId={selectedCategory.categoryCode}
                                        totalAmount={categoryTotalAmount || 0}
                                        changeCategoryFilter={this.changeCategoryFilter}
                                    />
                                    <ExpensesByCategoryInfo
                                        selectedCategory={selectedCategory}
                                        currency={currency}
                                        hasActivedFilters={hasActivedFilters}
                                        movementsTotalAmount={movementsTotalAmount}
                                        movementsAmount={movementsQuantity}
                                        onFilter={this.handleOnFilter}
                                        onClearFilter={this.handleClearFilter}
                                        onResetFilters={this.handleResetFilters}
                                        onOpenModal={this.handleOnOpenModal}
                                    />
                                    <ExpensesByCategoryViewNewTable
                                        canChangeCategory={!isPfmAggregatorView}
                                        selectedCategory={selectedCategory}
                                        getCategoryMovements={this.getMovementsByCategoryCode}
                                        onFilter={this.handleOnFilter}
                                        currency={currency}
                                        hasAppliedFilters={this.state.hasAppliedFilters}
                                        immAccounts={immAccounts}
                                        immCards={immCards}
                                        immFilters={immFilters}
                                        categoriesList={categoriesList}
                                    />
                                </OKLoadingErrorMessage>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

ExpensesByCategoryView.propTypes = {
    bankList: PropTypes.array.isRequired,
    categoriesList: PropTypes.object.isRequired,
    categoriesListError: PropTypes.bool.isRequired,
    categoriesListFetching: PropTypes.bool.isRequired,
    categoriesTabSelector: PropTypes.object,
    chartData: PropTypes.object,
    chartDataCompare: PropTypes.object,
    currency: PropTypes.string,
    error: PropTypes.bool,
    errorCompare: PropTypes.bool,
    fallbackFilters: PropTypes.func,
    fetching: PropTypes.bool,
    fetchingCompare: PropTypes.bool,
    histogramDatatError: PropTypes.bool,
    histogramDataFetching: PropTypes.bool,
    immFilters: PropTypes.object,
    immAccounts: PropTypes.object,
    immCards: PropTypes.object,
    immAggregatorData: PropTypes.object,
    movementsData: PropTypes.object,
    movementsDataError: PropTypes.bool,
    movementsDataFetching: PropTypes.bool,
    requestCategoriesTabs: PropTypes.func,
    requestCategoryMovements: PropTypes.func.isRequired,
    requestHistogram: PropTypes.func.isRequired,
    requestListCategories: PropTypes.func.isRequired,
    resetFilters: PropTypes.func,
    setSelectFilter: PropTypes.func,
    totalAmount: PropTypes.number,
    setApplied: PropTypes.func,
    initCheckFilter: PropTypes.func,
    initDateFilter: PropTypes.func,
    isPfmAggregatorView: PropTypes.bool,
    immFlagBasedFeatures: PropTypes.bool,
};

module.exports.constructor = ExpensesByCategoryView;
module.exports.ExpensesByCategoryView = connect(
    state => ({
        bankList: getBanksFromAggregatorData(state.aggregatorData),
        immAggregatorData: state.aggregatorData,
        currency: state.accounts.getIn(['balance', 0, 'currency']),
        categoriesList: state.expensesByCategoriesListCategories.get('categoriesList'),
        categoriesListFetching: state.expensesByCategoriesListCategories.get('fetching'),
        categoriesListError: state.expensesByCategoriesListCategories.get('error'),
        categoriesTabSelector: state.expensesByCategoriesTabSelector.get('categoriesTabSelector'),
        categoriesTabSelectorFetching: state.expensesByCategoriesTabSelector.get('fetching'),
        categoriesTabSelectorError: state.expensesByCategoriesTabSelector.get('error'),
        chartData: state.expensesByCategoriesMovements.get('chartData'),
        chartDataCompare: state.expensesByCategoriesMovements.get('chartDataCompare'),
        error: state.expensesByCategoriesMovements.get('error'),
        fetching: state.expensesByCategoriesMovements.get('fetching'),
        errorCompare: state.expensesByCategoriesMovements.get('errorCompare'),
        fetchingCompare: state.expensesByCategoriesMovements.get('fetchingCompare'),
        histogramDatatError: state.expensesByCategoriesMovements.get('error'),
        histogramDataFetching: state.expensesByCategoriesMovements.get('fetching'),
        movementsData: state.expensesByCategoriesMovementsCategory.get('movementsData'),
        movementsDataFetching: state.expensesByCategoriesMovementsCategory.get('fetchingMovements'),
        movementsDataError: state.expensesByCategoriesMovementsCategory.get('errorMovements'),
        immAccounts: state.accounts,
        immCards: state.cards,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immFilters: state.filters.get(PFM_FILTERS),
        totalAmount: Math.abs(state.expensesByCategoriesMovements.getIn(['histogramData', 'total'])),
    }),
    {
        initFilter,
        initCheckFilter,
        initDateFilter,
        fallbackFilters,
        resetFilters,
        setSelectFilter,
        requestListCategories,
        requestHistogram,
        requestCategoryMovements,
        requestCategoriesTabs,
        setDateFilter,
        setApplied
    }
)(ExpensesByCategoryView);

